import DateFilterService from '../../services/date-filter-service';

export default class LiveStreamEvent {
  constructor(data) {
    /**
     * Sport id
     * @type {string}
     */
    this.externalSportId = data.esid;
    /**
     * Sport name
     * @type {string}
     */
    this.sportName = data.sn;
    /**
     * Sport class name
     * @type {string}
     */
    this.sportClass = this.mapClassName(data);
    /**
     * Stream provider category id
     * @type {string}
     */
    this.externalCategoryId = data.ecid;
    /**
     * Category name
     * @type {string}
     */
    this.categoryName = data.cn;
    /**
     * Stream provider tournament id
     * @type {string}
     */
    this.externalTournamentId = data.etid;
    /**
     * Tournament name
     * @type {string}
     */
    this.tournamentName = data.tn;
    /**
     * Stream provider Match id
     * @type {string}
     */
    this.externalEventId = data.eeid;
    /**
     * SB Match id
     * @type {string}
     */
    this.internalEventId = data.ieid;
    /**
     * Away team name
     * @type {string}
     */
    this.awayTeam = data.at;
    /**
     * Home team name
     * @type {string}
     */
    this.homeTeam = data.ht;
    /**
     * Flag is event live
     * @type {boolean}
     */
    this.isLive = data.lve;
    /**
     * Flag is event active
     * @type {boolean}
     */
    this.isActive = data.act;
    /**
     * Integration broker (channel) id
     * @type {import('./livestream.const').TSTREAM_PROVIDERS_VALUES}
     */
    this.integrationBrokerId = data.ibid;
    /**
     * Raw api match datetime string
     * @type {string}
     */
    this.matchDateTime = data.mdt;
    /**
     * Formated time string
     * @type {string}
     */
    this.date = DateFilterService
      .localDate(data.mdt, 'datetime', APP_SETTINGS.formatting.shortDateFormat, APP_SETTINGS.formatting.shortTimeFormat, true);
    /**
     * Raw api end match datetime string
     * @type {string}
     */
    this.endDate = data.emdt;
    /**
     * Formated time string
     * @type {string}
     */
    this.endRaceDate = DateFilterService
      .localDate(data.emdt, 'datetime', APP_SETTINGS.formatting.shortDateFormat, APP_SETTINGS.formatting.shortTimeFormat, true);
    /**
     * Stream id
     * @type {string}
     */
    this.streamId = data.stid;
  }

  /**
   * Map class name to our interal class names
   * @param data - raw data object
   */
  mapClassName({ ibid = -1, esid = '', sn = '' } = {}) {
    if (ibid === 3 && esid === "6") {
      return 'soccer';
    }
    return sn.toLowerCase().replace(' ', '-');
  }
}
